module.exports = __webpack_public_path__ + "img/josh-berman.87d24dc9.png";